import { Controller } from 'stimulus'

/**
 * 内包するフォームコントロールの invalid イベントをキャプチャして
 * 自身に -invalid クラスを付与するだけのコントローラー。
 */
export default class extends Controller {
  connect() {
    this.onInvalid = this.onInvalid.bind(this)

    // useCapture: true をしたいので data-action は使わずここでイベント登録する。
    // もう少しで使えるようになるはず: https://github.com/stimulusjs/stimulus/pull/232
    this.element.addEventListener('invalid', this.onInvalid, true)
  }

  disconnect() {
    this.element.removeEventListener('invalid', this.onInvalid)
  }

  onInvalid() {
    this.element.classList.add('-invalid')
  }
}
